import { createSelector } from 'reselect'

export const getNotifications = state => state.get('notifications')

export const getNotificationsList = createSelector(getNotifications, notifications =>
  notifications.get('notifications')
)

export const getNotificationsPending = createSelector(getNotifications, notifications => notifications.get('pending'))

export const getNotificationsPendingGetNotifications = createSelector(getNotificationsPending, pending =>
  pending.get('getNotifications')
)

export const getNotificationsPendingGetNotificationsLoadMore = createSelector(getNotificationsPending, pending =>
  pending.get('getNotificationsLoadMore')
)

export const getNotificationsLoaded = createSelector(getNotifications, notifications => notifications.get('loaded'))

export const getNotificationsLoadedGetNotifications = createSelector(getNotificationsLoaded, loaded =>
  loaded.get('getNotifications')
)

export const getNotificationsLoadedGetNotificationsLoadMore = createSelector(getNotificationsLoaded, loaded =>
  loaded.get('getNotificationsLoadMore')
)

export const getNotificationsPagination = createSelector(getNotifications, notifications =>
  notifications.get('notificationsPagination')
)

export const getNotificationsUnreadCount = createSelector(getNotifications, notifications =>
  notifications.get('unreadCount')
)
